import React from "react";
import { Button } from "@components/common/button";
import { useNavigate } from "react-router-dom";
import useTranslator from "@pma/hooks/use-translator";
import { DASHBOARD_PAGE_ROUTE } from "@pma/utils/page-routes";
import { cn } from "@pma/utils/helpers";

interface Props {
  message?: string;
  status?: number;
  sm?: boolean;
}
const UnauthorizedCard = ({ message, status, sm }: Props) => {
  const navigate = useNavigate();
  const { translate } = useTranslator();

  return (
    <div
      className={cn(
        "m-auto flex w-full flex-col items-center justify-center gap-2",
        sm ? "h-[25vh]" : "h-50vh]",
      )}
    >
      <h1 className='text-[7rem] font-bold leading-tight'>{status ? status : "403"}</h1>
      <span className='font-medium capitalize text-red-500'>
        {message ? translate(message) : translate("Permission denied")}!
      </span>
      <small>{translate("Please contact your workspace administrator")}.</small>
      {!sm && (
        <div className='mt-6 flex gap-4'>
          <Button variant='outline' className='capitalize' onClick={() => navigate(-1)}>
            {translate("Go back")}
          </Button>
          <Button onClick={() => navigate(DASHBOARD_PAGE_ROUTE)}>{translate("Dashboard")}</Button>
        </div>
      )}
    </div>
  );
};

export default UnauthorizedCard;
